import React, { useCallback, useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  changeStudyStatusReducer,
  mapDispatchToProps,
} from "./ChangeStudyStatus.store";
import ChangeStudyStatus from "../../library/ChangeStudyStatus/ChangeStudyStatus";
import { studyStatusOptions } from "../../../modules/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";

export const SmartChangeStudyStatus = (props) => {
  const {
    studyEnrollmentID,
    studyStatusID,
    onUpdate,
    onCancel,
    updateStudyStatus,
    currentDailyTargets,
  } = props;
  const [processing, setIsProcessing] = useState(false);

  const onSubmit = (studyStatus, dailyTarget, reason) => {
    if (studyStatus) {
      setIsProcessing(true);
      updateStudyStatus(studyStatus.id, studyEnrollmentID, dailyTarget, reason)
        .then((message) => {
          sendNotification(message, ToastType.SUCCESS);
          onUpdate();
        })
        .catch((error) => {
          sendNotification(error, ToastType.ERROR);
        })
        .finally(() => {
          setIsProcessing(false);
        });
    }
  };

  const getCurrentStudyStatus = useCallback(() => {
    return (
      studyStatusOptions[
        Object.keys(studyStatusOptions).find(
          (statusKey) => studyStatusOptions[statusKey].id === studyStatusID
        )
      ] || []
    );
  }, [studyStatusID]);

  return (
    <ChangeStudyStatus
      currentStatus={getCurrentStudyStatus()}
      onSubmit={onSubmit}
      onCancel={onCancel || onUpdate}
      processing={processing}
      currentDailyTargets={currentDailyTargets}
    />
  );
};

export default dynamic(
  "changeStudyStatusReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(changeStudyStatusReducer)
)(connect(null, mapDispatchToProps)(SmartChangeStudyStatus));
